import React, { useCallback, useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import request from '../../../utils/Request.utils';

import './FormComponent.css'; // 외부 CSS 파일을 import

const getOptionByRefund = (detail) => {
    if (detail?.refund_stat === '환불불가') {
        return '1';
    }

    if (detail?.refund_stat === '환불 성공') {
        const refundAmt = Number(detail?.refund_amt || 0);
        const requestAmt = Number(detail?.refund_app_amt || 0);

        return refundAmt > 0 && refundAmt < requestAmt ? '3' : '2';
    }

    return '1';
};

const getAmtByRefund = (detail, option) => {
    if (option === '1') {
        return '';
    }

    if (option === '2') {
        return detail?.refund_app_amt ? String(detail.refund_app_amt) : '';
    }

    return detail?.refund_amt ? String(detail.refund_amt) : '';
};

const RefundView = () => {
    const { rd_seq } = useParams();
    const [refund, setRefund] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [Message, setMessage] = useState('');
    const [Amt, setAmt] = useState('');
    const [selectedOption1, setSelectedOption1] = useState('1'); // 첫 번째 라디오 버튼 그룹의 선택된 값

    const fetchRefundData = useCallback(async () => {
        try {
            const successHandler = (response) => {
                if (response.messageCode === 200) {
                    const detail = response.data?.detail?.[0];

                    if (!detail) {
                        setRefund(null);
                        toast.error('환불 정보를 찾을 수 없습니다.');
                        setLoading(false);
                        return;
                    }

                    const option = getOptionByRefund(detail);

                    setRefund(detail);
                    setMessage(detail.message || '');
                    setSelectedOption1(option);
                    setAmt(getAmtByRefund(detail, option));
                    setLoading(false);
                } else {
                    toast.error('결제 정보를 불러오는 중 오류가 발생했습니다.');
                    setLoading(false);
                }
            };

            const errorHandler = (error) => {
                toast.error('결제 정보를 불러오는 중 오류가 발생했습니다.');
                setLoading(false);
            };
            // /admin/detail
            await request.post(`/refund/admin/detail`, { rd_seq: rd_seq }, successHandler, errorHandler);
        } catch (error) {
            toast.error('결제 정보를 불러오는 중 오류가 발생했습니다.');
            setLoading(false);
        }
    }, [rd_seq]);

    useEffect(() => {
        if (rd_seq) {
            ///admin/userpoint
            fetchRefundData();
        }
    }, [rd_seq, fetchRefundData]);

    useEffect(() => {
        if (refund?.owner_seq) {
            const fetchPointData = async () => {
                try {
                    const successHandler = (response) => {
                        if (response.messageCode === 200) {
                            console.log(response.data);
                        } else {
                        }
                    };

                    const errorHandler = (error) => {};
                    // /admin/detail
                    await request.post(
                        `/points/admin/userpoint`,
                        { owner_seq: refund.owner_seq },
                        successHandler,
                        errorHandler
                    );
                } catch (error) {}
            };

            ///admin/userpoint
            fetchPointData();
        }
    }, [refund]);

    const isProcessed = refund?.refund_stat && refund.refund_stat !== '환불 요청';

    const handleOption1Change = (e) => {
        if (isProcessed) {
            return;
        }

        const nextOption = e.target.value;

        setSelectedOption1(nextOption); // 첫 번째 라디오 버튼 그룹의 선택된 값을 변경

        if (nextOption === '1') {
            setAmt('');
        } else if (nextOption === '2') {
            setAmt(refund?.refund_app_amt ? String(refund.refund_app_amt) : '');
        } else {
            setAmt('');
        }
    };

    const genAmt = (am) => {
        switch (am) {
            case '1':
                return 0;
            case '2':
                return refund?.refund_app_amt || 0;
            case '3':
                return Amt;
            default:
                return '환불 오류';
        }
    };

    const setStatus = (text) => {
        switch (text) {
            case '1':
                return 'PAY06';
            case '2':
                return 'PAY04';
            case '3':
                return 'PAY04';
            default:
                return '';
        }
    };

    const handleSubmit = async () => {
        try {
            const message = '환불 후에는 변경이 불가능합니다.\n정말 환불을 진행하시겠습니까?';

            const successHandler = (response) => {
                if (response.messageCode === 200 && response.data?.bool) {
                    toast.success('환불 정보가 저장되었습니다.');
                    fetchRefundData();
                } else {
                    toast.error('환불 정보가 저장되지 않았습니다.');
                }
                setIsSubmitting(false);
            };

            const errorHandler = (error) => {
                toast.error('환불 정보를 수정 중 오류가 발생했습니다.');
                setIsSubmitting(false);
            };
            // /admin/update
            // owner_seq
            // adjs_points
            // sum_points
            if (isProcessed) {
                toast.info('이미 처리된 환불 건입니다.');
                return false;
            }

            const refundAmt = Number(genAmt(selectedOption1) || 0);
            const requestAmt = Number(refund?.refund_app_amt || 0);

            const param = {
                message: Message,
                refund_stat: setStatus(selectedOption1),
                refund_amt: refundAmt,
                rd_seq: rd_seq,
                owner_seq: refund?.owner_seq,
                adjs_points: refundAmt,
                point: refund?.refund_app_amt,
            };

            if (selectedOption1 === '3' && !Amt) {
                alert('환불 금액을 입력해주세요.');
                return false;
            }
            if (requestAmt < refundAmt) {
                alert('입력하신 금액이 환불 가능 금액보다 높습니다.');
                return false;
            }

            if (window.confirm(message)) {
                // 사용자가 확인을 눌렀을 경우 처리할 로직
                setIsSubmitting(true);
                await request.post(`/refund/admin/update`, param, successHandler, errorHandler);
            } else {
                // 사용자가 취소 또는 닫기를 선택했을 경우 처리할 로직
                setIsSubmitting(false);
            }
        } catch (error) {
            toast.error('환불 정보를 수정 중 오류가 발생했습니다.');
            setIsSubmitting(false);
        }
    };

    if (loading) {
        return <p>Loading...</p>;
    }

    if (!refund) {
        return (
            <main>
                <h2 className="adm_com_pg_tit">결제 환불신청 &gt; 상세보기</h2>
                <p>환불 정보를 찾을 수 없습니다.</p>
                <div className="adm_com_btn_wrap bottom center">
                    <Link to="/Refund/History" className="adm_com_btn black">
                        목록
                    </Link>
                </div>
                <ToastContainer />
            </main>
        );
    }

    return (
        <main>
            <h2 className="adm_com_pg_tit">결제 환불신청 &gt; 상세보기</h2>
            <table className="adm_com_board_list type_row">
                <colgroup>
                    <col width="10%" />
                    <col width="40%" />
                    <col width="10%" />
                    <col width="40%" />
                </colgroup>
                <tbody>
                    {/* admin_seq: null
            message: null
            owner_seq: 1
            rd_seq: 1
            refund_amt: null
            refund_app_amt: 95000
            refund_app_dtm: "2024-06-12"
            refund_dtm: null
            refund_stat: "PAY03"
            refund_ty: "point"
            reg_dtm: "2024-06-12"
            user_email: "45584@gmail.com"
            user_seq: 10 */}
                    <tr>
                        <th>환불 요청일</th>
                        <td colSpan={3}>{refund.reg_dtm}</td>
                    </tr>
                    <tr>
                        <th>환불 요청자</th>
                        <td colSpan={3}>{refund.user_email}</td>
                    </tr>
                    <tr>
                        <th>연락처</th>
                        <td colSpan={3}>{'-'}</td>
                    </tr>
                    <tr>
                        <th>포인트 환불 요청금액</th>
                        <td colSpan={3}>{refund.refund_app_amt}</td>
                    </tr>
                    <tr>
                        <th>환불 일</th>
                        <td colSpan={3}>{!refund.refund_dtm ? '-' : refund.refund_dtm}</td>
                    </tr>
                    <tr>
                        <th>환불 상태</th>
                        <td colSpan={3}>{refund.refund_stat}</td>
                    </tr>
                </tbody>
            </table>

            <div className="form-container">
                <div className="form-row">
                    <div className="form-item">
                        <div className="radio-group">
                            <label>
                                <input
                                    type="radio"
                                    name="option1"
                                    value="1"
                                    checked={selectedOption1 === '1'}
                                    disabled={isProcessed}
                                    onChange={handleOption1Change}
                                />
                                <div className={`adm_com_btn ${selectedOption1 === '1' ? `red` : `black`}`}>
                                    환불불가
                                </div>
                            </label>
                            <label>
                                <input
                                    type="radio"
                                    name="option1"
                                    value="2"
                                    checked={selectedOption1 === '2'}
                                    disabled={isProcessed}
                                    onChange={handleOption1Change}
                                />
                                <div className={`adm_com_btn ${selectedOption1 === '2' ? `red` : `black`}`}>
                                    전액환불
                                </div>
                            </label>
                            <label>
                                <input
                                    type="radio"
                                    name="option1"
                                    value="3"
                                    checked={selectedOption1 === '3'}
                                    disabled={isProcessed}
                                    onChange={handleOption1Change}
                                />
                                <div className={`adm_com_btn ${selectedOption1 === '3' ? `red` : `black`}`}>
                                    부분환불
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="form-item">
                        <input
                            type="number"
                            placeholder="환불 금액 입력"
                            disabled={isProcessed || selectedOption1 !== '3'}
                            value={Amt}
                            onChange={(e) => setAmt(e.target.value)}
                        />
                    </div>
                    <div className="form-item">
                        <input
                            type="text"
                            placeholder="메시지 입력"
                            disabled={isProcessed}
                            value={Message}
                            onChange={(e) => setMessage(e.target.value)}
                        />
                    </div>
                    <div className="form-item">
                        <button
                            type="button"
                            className={`adm_com_btn ${isProcessed ? `gray` : `blue`}`}
                            disabled={isProcessed || isSubmitting}
                            onClick={handleSubmit}
                        >
                            확인
                        </button>
                    </div>
                </div>
            </div>

            <div className="adm_com_btn_wrap bottom center">
                {/* <button className="adm_com_btn blue">취소하기</button> */}
                <Link to="/Refund/History" className="adm_com_btn black">
                    목록
                </Link>
            </div>
            <ToastContainer />
        </main>
    );
};

export default RefundView;
